import { useState } from "react";
import { TValueOption } from "../components/ValueCellSelector";
import { Button, KIND, SHAPE, SIZE } from "baseui/button";
import { VscAdd } from "react-icons/vsc";
import AddEntryDialog, { IAddEventState } from "./AddEntryDialog";

const AddEntryButton: React.FC<{
    dataType: string,
    onAdd: (args: IAddEventState) => void,
    showDays: boolean,
    valueOptions: TValueOption[] | undefined
  }> = (props) => {
  
    const [isOpen, setIsOpen] = useState(false);
  
    return (
      <>
        <Button onClick={() => setIsOpen(true)} kind={KIND.primary} size={SIZE.default} shape={SHAPE.round} overrides={{
          BaseButton: {
            style: ({ $theme }) => ({
              boxShadow: $theme.lighting.shadow400,
            })
          }
        }}
        >
          <VscAdd></VscAdd>
        </Button>
        <AddEntryDialog valueOptions={props.valueOptions} showDays={props.showDays} dataType={props.dataType} onAdd={props.onAdd} isOpen={isOpen} setIsOpen={setIsOpen} />
      </>
    )
  };

  export default AddEntryButton;